import { useQuery } from "react-query";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Conversation } from "../components/common/ConversationItem";
import type { ConversationChannelFilterOptions } from "../types/ConversationChannelFilterOptions";
import type { ConversationStatusFilterOptions } from "../types/ConversationStatusFilterOptions";

interface ConversationFilters {
  status: ConversationStatusFilterOptions;
  type: ConversationChannelFilterOptions;
}

interface ApiResponse {
  conversations: Conversation[];
  error?: string;
}

export const useListConversations = ({ type, status }: ConversationFilters) => {
  const listConversations = (): Promise<ApiResponse> =>
    reactQueryGet(
      internalApi.helpWidget.listConversations({
        conversationFilters: {
          channel_type: type,
          status,
        },
      }),
    );

  return useQuery(
    ["help-widget", "conversations", type, status],
    listConversations,
  );
};
